// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page_container-module__container--sT6ye{width:100%;margin:0;padding:40px 24px 56px}@media screen and (max-width: 62.5625em){.page_container-module__container--sT6ye{padding-right:0px;padding-left:0px;padding-bottom:30px}}\n", ""]);
// Exports
exports.locals = {
	"container": "page_container-module__container--sT6ye"
};
module.exports = exports;
